import React from "react";
import {connect} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {mapHeaderDispatchToProps} from "./Container";
import {faWifi} from "@fortawesome/pro-solid-svg-icons/faWifi";
import {FullSizeIconWithText} from "../../Core/LoadingAnimation";
import Box from "@mui/material/Box";

export let ERROR_TYPES = {
    CONNECTION: 'CONNECTION'
}

let getIconByType = (type) => {
    if (type === ERROR_TYPES.CONNECTION) {
        return faWifi
    }

    return null;
}

let getTitleByType = (type) => {
    if (type === ERROR_TYPES.CONNECTION) {
        return "Network error"
    }

    return null;
}

let getContentByType = (type) => {
    if (type === ERROR_TYPES.CONNECTION) {
        return <FullSizeIconWithText
            icon={<Box color={"error.dark"}> <FontAwesomeIcon icon={getIconByType(type)} size='2x'/> </Box>}
            text={<>
                <h1><Box color={"error.dark"}> Error connecting to server. </Box></h1>
                <a href={"/"}> Click here to try again. </a>
            </>
            }
            shrinkLeft
        />


    }

    return null;
}

function Error({setHeader, type}) {
    React.useEffect(() => {
        setHeader(getTitleByType(type), <FontAwesomeIcon icon={getIconByType(type)}/>)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <>
        {getContentByType(type)}
    </>;
}

const mapStateToProps = () => {
    return {}
};

const ContainerError = connect(
    mapStateToProps,
    mapHeaderDispatchToProps,
)(Error);

export default ContainerError;